import {createSelector} from 'helpers';
import {createdDate, createdDateNegative} from 'store/common';

export const settings = createSelector(
  [ state => state.settings.lists ],
  ( settings = {} ) => ({
    sort: 'newest',
    filter: 'all',
    ...settings,
  })
);

export const sort = createSelector(
  ( settings ),
  ({ sort }) => {
    const result = sort === 'oldest' ? [ 'date', createdDate ] : [list => -1*list.created, createdDateNegative ];
    result.name = sort;
    return result;
  }
);
